export const common = ({ data = [], backgroundColor, ...props }) => ({
  backgroundColor: backgroundColor,
  title: {
    // text: props.title,
    textStyle: {
      fontSize: 16,
      color: 'rgba(255, 255, 255, 0.9)',
      align: 'center',
    }
  },
  grid: {
    show: false,
    top: 0,
    left: 0,
    right: 0,
    bottom: -20,
    containLabel: true,
  },
  calculable: true,
  xAxis: [
    {
      show: false,
      type: 'value',
      boundaryGap: [0, 0.01],
      splitLine: {
        show: false, // 是否显示分割线
      },
    }
  ],
  yAxis: [
    {
      show: true,
      type: 'category',
      axisLine: { // Y轴线
        "show": false
      },
      splitLine: {
        show: false, // 是否显示分割线
      },
      axisTick: { // Y轴刻度线
        "show": false
      },
      data: data.map(a => (a.name || a.text || a.label || a.title)),
    }
  ],
  tooltip: {
    show: false,
  },
  ...props,
});

export const linearColor = (begin = '#53c9d3', final = '#53b3ff') => {
  return {
    type: 'linear', // 线性渐变
    x: 0,
    y: 0,
    x2: 1,
    y2: 0,
    colorStops: [
      {
        offset: 0,
        color: begin // 0%处的颜色为红色
      },
      {
        offset: 1,
        color: final // 100%处的颜色为蓝
      }
    ]
  }
}